import React, { useState } from 'react';
import ProductSelectBottomSheet from '../selection/ProductSelectBottomSheet';
import ProductQuantitiesBottomSheet from '../selection/ProductQuantitiesBottomSheet';
import { ProductSelectionWithQuantity } from '../selection/ProductSelectBottomSheet';
import { Product } from '@domain/product/models/Product';

export type ProductPartSelection = ProductSelectionWithQuantity;

interface AddProductPartsBottomSheetProps {
  productId?: string;
  existingPartProductIds: Set<string>;
  onAdd: (selections: ProductPartSelection[]) => Promise<void>;
  onClose?: () => void;
}

const AddProductPartBottomSheet: React.FC<AddProductPartsBottomSheetProps> = ({
  productId,
  existingPartProductIds,
  onAdd,
  onClose,
}) => {
  const [step, setStep] = useState<'select' | 'quantities'>('select');
  const [pickedProducts, setPickedProducts] = useState<Product[]>([]);

  const excludeIds = new Set(existingPartProductIds);
  if (productId) excludeIds.add(productId);

  const selectKey = `parts-select-${pickedProducts.map(p => p.id).sort().join(',')}`;

  if (step === 'select') {
    return (
      <ProductSelectBottomSheet
        key={selectKey}
        title="Add Parts"
        initialProducts={pickedProducts}
        excludeProductIds={excludeIds}
        getDisabledCaption={id =>
          productId && id === productId ? 'Current product' : 'Already added'
        }
        confirmButtonText={count =>
          count === 0 ? 'Continue' : `Continue with ${count} product${count !== 1 ? 's' : ''}`
        }
        onFinish={selections => {
          setPickedProducts(selections.map(s => s.product));
          setStep('quantities');
        }}
        onClose={() => onClose?.()}
      />
    );
  }

  return (
    <ProductQuantitiesBottomSheet
      key="parts-quantities"
      products={pickedProducts}
      title="Set quantities"
      hint="How many of each product should be used as a part?"
      confirmButtonText={count => `Add ${count} part${count !== 1 ? 's' : ''}`}
      onFinish={onAdd}
      onBack={() => setStep('select')}
      onClose={() => onClose?.()}
    />
  );
};

export default AddProductPartBottomSheet;
